import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { AngularMaterialModule } from "../../angular-material.module";
import { CheckoutService } from "../checkout.service";

@Component({
  selector: "app-payment-roster-return",
  standalone: true,
  imports: [CommonModule, RouterModule, AngularMaterialModule],
  templateUrl: "./payment-roster-return.component.html",
  styleUrls: ["./payment-roster-return.component.css"],
})
export class PaymentRosterReturnComponent implements OnInit {
  isLoading = true;
  success = false;
  statusMessage = "Verifying your payment...";
  teamName = "";
  seasonName = "";
  amountPaid = 0;
  teamId = "";
  returnToDashboard = false;
  /** When set, back link opens this roster tab (e.g. payments after team balance checkout). */
  returnTab: string | null = null;

  constructor(private checkoutService: CheckoutService) {}

  ngOnInit(): void {
    const sessionId = new URLSearchParams(window.location.search).get(
      "session_id"
    );
    if (!sessionId) {
      this.isLoading = false;
      this.statusMessage = "Missing payment session.";
      return;
    }
    this.verify(sessionId);
  }

  private async verify(sessionId: string): Promise<void> {
    try {
      const response = await this.checkoutService.getSessionStatus(sessionId);
      const isRosterShare = response.flow === "roster_share";
      const isTeamBalance = response.return_to === "team_payments";
      const isDashboardPayment = response.return_to === "dashboard";

      if (
        response?.status === "complete" &&
        response.payment_status === "paid" &&
        (isRosterShare || isTeamBalance)
      ) {
        this.teamName = response.team_name || "";
        this.seasonName = response.season_name || "";
        this.teamId = response.team_id || "";
        this.returnTab = isTeamBalance ? "payments" : null;
        this.returnToDashboard = isDashboardPayment;
        this.amountPaid = response.amount_total
          ? response.amount_total / 100
          : 0;
        this.success = true;
      } else {
        this.statusMessage = "We could not confirm this payment.";
      }
    } catch {
      this.statusMessage = "Something went wrong verifying your payment.";
    } finally {
      this.isLoading = false;
    }
  }
}
